const SESSION_FLAG = 'cadencya:show-login-alerts';

export const markLoginAlertsPending = () => {
  try {
    sessionStorage.setItem(SESSION_FLAG, '1');
  } catch {
    /* noop */
  }
};

export const clearLoginAlertsPending = () => {
  try {
    sessionStorage.removeItem(SESSION_FLAG);
  } catch {
    /* noop */
  }
};

export const hasPendingLoginAlerts = () => {
  try {
    return sessionStorage.getItem(SESSION_FLAG) === '1';
  } catch {
    return false;
  }
};
